import { ShellModel } from '../../shell/data-store';

export class StallionItemModel {
  id: number;
  timestamp: string;
  detailsUrl: string;
  image: string;
  name: string;
  breed: string[];
  disciplines: string[];
  description: string;
  shortDescription2: string;
  fullDescription: string;
  address: string;
  height: number;
  color: string[];
  studfee: number;
  breedingFeeCurrency: string;
  shipment: string;
  json: string;
}

export class StallionListingModel extends ShellModel {
  items: Array<StallionItemModel> = [
  ];

  constructor() {
    super();
  }
}
